export const initialFormData = {
  name: "",
  notes: "",
  firstName: "",
  lastName: "",
  businessEmail: "",
  phone: "",
  jobTitle: "",
  businessName: "",
  newsletter: false,
  terms: false,
};

export const formFields = [
  {
    name: "name",
    label: "Give Your Quote A Name or Number *",
    type: "text",
    tag: "input",
    required: true,
    wrapperClass: "flex flex-col w-full md:w-2/5 mb-11 gap-[6px]",
    className: "border border-gray w-full text-base py-5 px-3",
  },
  {
    name: "notes",
    label: "Additional Notes (optional)",
    type: "text",
    tag: "textarea",
    required: false,
    wrapperClass: "flex flex-col w-full md:w-[49%] mb-12 gap-[6px]",
    className: "border border-gray w-full text-base py-5 px-3 min-h-[184px]",
  },
  {
    name: "firstName",
    label: "First Name *",
    type: "text",
    tag: "input",
    required: true,
    wrapperClass: "flex flex-col w-full mb-0 gap-[6px]",
    className: "border border-gray w-full text-base py-5 px-3",
  },
  {
    name: "lastName",
    label: "Last Name *",
    type: "text",
    tag: "input",
    required: true,
    wrapperClass: "flex flex-col w-full mb-0 gap-[2px]",
    className: "border border-gray w-full text-base py-5 px-3",
    hasExtraLabel: true,
  },
  {
    name: "businessEmail",
    label: "Business Email *",
    type: "email",
    tag: "input",
    required: true,
    wrapperClass: "flex flex-col w-full mb-0 gap-[6px]",
    className: "border border-gray w-full text-base py-5 px-3",
  },
  {
    name: "phone",
    label: "Phone",
    type: "text",
    tag: "input",
    required: false,
    wrapperClass: "flex flex-col w-full mb-0 gap-[6px]",
    className: "border border-gray w-full text-base py-5 px-3",
  },
  {
    name: "jobTitle",
    label: "Job Title *",
    type: "text",
    tag: "input",
    required: true,
    wrapperClass: "flex flex-col w-full mb-0 gap-[6px]",
    className: "border border-gray w-full text-base py-5 px-3",
  },
  {
    name: "businessName",
    label: "Business / Organization Name *",
    type: "text",
    tag: "input",
    required: true,
    wrapperClass: "flex flex-col w-full mb-0 gap-[6px]",
    className: "border border-gray w-full text-base py-5 px-3",
  },
];